// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2vxVA","row":"Node_row__29J4F","label":"Node_label__2AtPy","footer":"Node_footer__msI4K"};